namespace SPA {

	export namespace Contacts {

		export class Modal {
			private mForm: JQuery;
			private Company: Wollmilch.CompanyObject;
			private data: { [key: string]: ui.base.BaseHTMLElement } | null;
			private ObjectNumber: string;
			private Callback: ((data: SPA.Contact) => void) | undefined;

			public constructor(company: Wollmilch.CompanyObject) {
				this.Company = company;
				this.mForm = $('body > .modal');
				this.data  = null;
				this.ObjectNumber = '';
				this.Callback = undefined;
			}

			public setData(data: { [key: string]: ui.base.BaseHTMLElement } | null): this
			{
				this.data = data;
				return this;
			}

			public setObjectNumber(object_number: string): this
			{
				this.ObjectNumber = object_number;
				return this;
			}

			public setCallback(cbfunc: (data: any) => void): this
			{
				this.Callback = cbfunc;
				return this;
			}

			public setTitle(title: string): this {
				this.mForm.find('.modal-title').text(title);
				return this;
			}

			public setPrimaryButtonText(text: string): this
			{
				this.mForm.find('.btn-primary').text(text);
				return this;
			}

			public setType(type?: IContactStatusName): this
			{
				const row = ui.$$.div().addClass('row');
				const Adresse = new ui.base.BaseHTMLElement('div')
					.addClass('col-xs-12')
					.appendTo(row);

				const orderForm = new ui.Form.Form(
					{
						action: '',
						method: 'POST',
						notSwitchable: true,
						submit: () => {
							return;
						}
					});

				const adr_list = SPA.gui.form.SimpleStyledPostalAddress(
					orderForm,
					Adresse,
					'',
					{},
					"hidden"
				);

				const formBody =
					$('<form>').attr('id', 'modalContactForm').append(
						ui.$$.div().addClass('row').append(`
							<div class="col-sm-2">
								<label class="control-label">Anrede</label>
								<select class="form-control" name="salutation" required>
									<option value="MR" selected>Herr</option>
									<option value="MRS">Frau</option>
								</select>
							</div>
							<div class="col-sm-4">
								<label class="control-label">Vorname</label>
								<input class="form-control" type="text" name="name" value="" required>
							</div>
							<div class="col-sm-4">
								<label class="control-label">Nachname</label>
								<input class="form-control" type="text" name="surname" value="" required>
							</div>
							<div class="col-sm-2">
								<label class="control-label">Titel</label>
								<input class="form-control" type="text" name="title" value="">
							</div>`)
							.add(row)
							.add(`<div class="row">
									<div class="col-sm-4">
										<label class="control-label">Telefon</label>
										<input class="form-control" type="text" name="phone" value="">
										<input type="hidden" name="fax" value="">
									</div>
									<div class="col-sm-4">
										<label class="control-label">E-Mail</label>
										<input class="form-control" type="text" name="email" value="">
									</div>
									<div class="col-sm-4">
										<label class="control-label">Mobil</label>
										<input class="form-control" type="text" name="mobile" value="">
									</div>
									<!--<div class="col-sm-3">
										<label class="control-label">Geburtstag</label>
										<input class="form-control" type="date" name="birthdate" value="">
									</div>-->
								</div>
								<input type="hidden" name="object_number" id="modal_object_number" value="${this.ObjectNumber}" />
								<input type="hidden" name="contractor_id" id="address_contractor_id" value="${this.Company.ID}" />
								<input type="hidden" name="types[]" value="${type}" />`));
				if ( type === 'contact') {
					formBody.append(`<div class="row">
							<div class="col-sm-4">
								<label class="checkbox-inline"><input id="customerCheck" type="checkbox" name="types[]" value="customer">Kunde</label>
							</div>
							<!-- <div class="col-sm-4">
								<label class="checkbox-inline"><input type="checkbox" name="types[]" value="adviser" disabled>Berater</label>
							</div>
							<div class="col-sm-4">
								<label class="checkbox-inline"><input type="checkbox" name="types[]" value="partner" disabled>Partner</label>
							</div> -->
						</div>`
					);
				}
				this.mForm.find('.modal-body').empty().append(formBody);

				this.mForm.find('.btn-primary').attr('form', 'modalContactForm');
				this.mForm.off('submit', 'form');
				this.mForm.on('submit', 'form', (e) => {
					e.preventDefault();
					const formData = $(e.currentTarget).serializeArray();
					const postData: { [name: string]: string } = {};
					for (const input of formData) {
						if (input.name.indexOf('[]') !== -1) {
							const baseName = input.name.substr(0, input.name.indexOf('['));

							if (postData[baseName] === undefined) {
								postData[baseName] = [];
							}
							postData[baseName].push(input.value);
						} else {
							postData[input.name] = input.value;
						}
					}
					// (contact: IContact) => {
					// 	app.getContactManager().link(contact.ContactID as number, this.ObjectNumber as string, type as IContactStatusName);
					// }
					app.getContactManager().createItem(postData, this.Callback);
					// Close the modal window anyway
					// todo decide when and where to close it
					this.mForm.modal('hide');
				});

				return this;
			}

			public getForm()
			{
				return this.mForm;
			}

			public show() {
				this.mForm.modal('show');
			}
		}
	}
}
